<template>
    <div class="jqm-footer">
        <div class="footer-box">
            <div class="box border-bt clearfix mb-20">
                <h2 class="title">redes sociais</h2>
                <ul class="social-media clearfix in-block">
                    <li><a target="_blank" rel="nofollow" href="http://www.facebook.com/MoblyBR"><i class="fa fa-facebook-square"></i></a></li>
                    <li><a target="_blank" rel="nofollow" href="http://www.twitter.com/moblybr"><i class="fa fa-twitter-square"></i></a></li>
                    <li><a target="_blank" rel="nofollow" href="http://www.youtube.com/user/MoblyBR"><i class="fa fa-youtube-square"></i></a></li>
                    <li><a target="_blank" rel="nofollow" href="https://plus.google.com/+MoblyBrParaVc/posts"><i class="fa fa-google-plus-square"></i></a></li>
                </ul>
            </div>

            <div class="box border-bt clearfix">
                <h2 class="title">Instale de graça o App da Mobly</h2>
                <ul class="clearfix in-block">
                    <li><a href="https://app.adjust.com/emiotf"><img src="https://static.mobly.com.br/cms/marketing/btn-app-store-footer.jpg" width="120" height="40" class="h-10"></a></li>
                    <li><a href="https://app.adjust.com/6pcf4m"><img src="https://static.mobly.com.br/cms/marketing/btn-app-google-play.jpg" width="120" height="40" class="h-10"></a></li>
                </ul>
            </div>

            <div class="box border-bt clearfix">
                <a href="/customer/account/" class="my-account">
                    <i class="fa fa-user"></i> minha conta
                </a>
            </div>

            <div class="box border-bt clearfix mb-20">
                <ul class="footer-menu clearfix">
                    <li><a :href="env.VUE_APP_URL + env.VUE_APP_MENU_PRIVACY">Política de privacidade</a></li>
                    <li><a :href="env.VUE_APP_URL + env.VUE_APP_MENU_AFFILIATE">Afiliados</a></li>
                    <li><a :href="env.VUE_APP_URL + env.VUE_APP_MENU_TERMS_OF_USE">Termos de uso</a></li>
                    <li><a :href="env.VUE_APP_URL + env.VUE_APP_MENU_PARTNER">Torne-se um parceiro</a></li>
                    <li><a :href="env.VUE_APP_URL">Versão desktop</a></li>
                </ul>
            </div>

            <div class="box clearfix">
                <p>Mobly Comércio Varejista Ltda. - CNPJ: 14.055.516/0004-90</p>
                <p>Endereço: Av. das Nações Unidas, 16737 Várzea de Baixo, São Paulo - SP - CEP 04730-090.</p>

                <br/>
                <p class="text-center"><strong>© 2021 Https://mobly.com.br. Todos os direitos reservados.</strong></p>
                <br/>
            </div>

        </div>
    </div>
</template>

<script>
export default {
  name: 'StaticFooter',
  computed: {
    env: function () {
      return process.env
    }
  }
}
</script>

<style lang="scss">
    @import "./../../styles/main-footer";
</style>
